<template>
  <div class="flex flex-row gap-2">
    <BlueButton text="+100" @click="moveAxis(100)"/>
    <BlueButton text="+10" @click="moveAxis(10)"/>
    <BlueButton text="+1" @click="moveAxis(1)"/>

    <SimpleText :content="axis" />

    <BlueButton text="-1" @click="moveAxis(-1)"/>
    <BlueButton text="-10" @click="moveAxis(-10)"/>
    <BlueButton text="-100" @click="moveAxis(-100)"/>
  </div>
</template>

<script setup>

import BlueButton from "@/components/molecules/BlueButton.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import {defineProps} from "vue";
import xhr from "@/utils/xhr";
import {t} from "@/utils/Traduction";
import {jsonValidator} from "@/utils/JsonValidator";
import {NotificationStores} from "@/stores/NotificationStores";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
  axis: {
    type: String,
    required: true,
  },
});

const notificationStore = NotificationStores();

const moveAxis = (distance) => {
  xhr.addRequestToQueue("POST", `/imprimantes/move/${props.uuid}/${props.axis}/${distance}`, null, true, true, false,
      (response) => {
        if (response.code !== 200) {
          if (response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringMoveAxis"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(
              t("axisMoved"),
              "success");
        }
      });
}
</script>

<style scoped>

</style>